import React, {useEffect, useState, useRef, Fragment} from "react";

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Box from "@material-ui/core/Box"
import moment from "moment";
import {useHistory} from "react-router-dom";

// 共通部品
import {
	apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
	apollo_budgetno_master_path,
	apollo_budget_path,
	apollo_budget_menu_path,
	apollo_menu_budget_check_path,
	zeus_ad_account,
} from "../../atom/Apollo_links";
import {
	AccountBudget,
	BudgetPutReq,
	BudgetMenuPutReq,
	Amount,
	AmountCheck,
  MAX_ACCOUNT_BUDGET,
} from "../../pages/BUDGET/BudgetModel";
import {BudgetnoMaster} from "../MASTER/Apollo_MasterModel";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {IsAccountGroupAuth, APOLLO_GROUP_OPERATOR} from "../../atom/Apollo_Authorization";
import ApolloTextNumber, {PropsTextNumber} from "../../atom/ACCOUNT/Apollo_TextNumber";
import ApolloTextNumberList, {PropsTextNumberList} from "../../atom/ACCOUNT/Apollo_TextNumberList";
import {ApolloButton} from "../../molecule/Apollo_ButtonBase";
import ApolloBudgetDeliveryType, {PropsBudgetDeliveryType} from "../../molecule/BUDGET/Apollo_BudgetDeliveryType";
// メッセージ定義
import {
	GetMessage,
	UI_BUDGET_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// 操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

// INT 安全最大値
// const MAX_INT = Number.MAX_SAFE_INTEGER;

export default function ApolloBudgetEdit(props: {
	accountId: number,
	accountgroupId: number,
	yearMonth: string,
	read: boolean,
	setRead: any,
	setParentYearMonth: any,
}) {
	const {accountId, accountgroupId, yearMonth, read, setRead, setParentYearMonth} = props;

	const classes = apollo_useStyles();
	const {data, setmsg} = React.useContext(ApolloMessage);
	const {state} = React.useContext(ApolloContext);

	const [disabledButton1, setDisabledButton1] = useState(true);
	// 初期表示状況
	const [progress, setProgress] = useState(true);
	// Zeus配信種別予算コンポーネント有効可否
	const [zeusIsDisabled, setZeusIsDisabled] = useState(false);
	// 初期値は当月
	const budgetMonth1 = moment().format("YYYYMM");
	const budgetMonth2 = moment().add(1, 'months').format("YYYYMM");
	const [budgetMonth, setBudgetMonth] = useState(yearMonth);
	// リンク表示用年月
	const dispMonth = moment().format("YYYY年M月");
	const dispNextMonth = moment().add(1, 'months').format("YYYY年M月");
	// ダイアログ表示用
	const [month, setMonth] = useState("当月");
	const [menuNames, setMenuNames] = useState("");
	// DBから取得するデータ
	const [accountBudget, setAccountBudget] = useState<AccountBudget>();
	const [budgetnoMaster, setBudgetnoMaster] = useState<BudgetnoMaster[]>([]);
	// アカウント月額予算
	const [budgetAmount, setBudgetAmount] = useState(0);
	const [budgetAmountBack, setBudgetAmountBack] = useState(0);
	const [nextBudgetAmount, setNextBudgetAmount] = useState(0);
	const [budgetDisabled, setBudgetDisabled] = useState<boolean>(false);
	// メニュー予算
	const [menuName, setMenuName] = useState<string[]>([]);
	const [menuDisabled, setMenuDisabled] = useState<boolean[]>([]);
	const [menuAmount, setMenuAmount] = useState<number[]>([]);
	// エラーメッセージ
	const [errorLocal, setErrorLocal] = useState<any>([]);
	const [errorMenuLocal, setErrorMenuLocal] = useState<any>([]);
	const errorMsg = useRef<any>({});
	const [messageOld, setMessageOld] = useState<any>([]);
	// メニュー当月・翌月予算 配列 [0]:当月 [1]:翌月
	const [minMenuAmount, setMinMenuAmount] = useState<number[][]>([]);
	const [maxMenuAmount, setMaxMenuAmount] = useState<number[][]>([]);
	// 合計予算
	const [totalAmount, setTotalAmount] = useState(0);
	// componentのprops
	// 設定可能金額
	const [registerableAmount, setRegisterableAmount] = useState(0);
	// 変更ボタン活性 (初期は非活性)
	const [updateAvailability, setUpdateAvailability] = useState(true);
	const [updateMenuAvailability, setUpdateMenuAvailability] = useState(true);
	// 旧予算額
	const [oldBudgetAmount, setOldBudgetAmount] = useState(0);
	const [oldNextBudgetAmount, setOldNextBudgetAmount] = useState(0);
	const [oldMenuAmountList, setOldMenuAmountList] = useState<number[][]>();
	const [oldMenuDisabled, setOldMenuDisabled] = useState<boolean[]>([]);
	// 再読み込み
	const [reRead, setReRead] = useState(true);
	// リセットボタンクリック有無
	const [reset, setReset] = useState(false);
	const [complete, setComplete] = useState(false);
	// メニュー予算更新API実行カウンタ(初回表示時はAPI更新しないようにカウンタとしている)
	const [menuApi, setMenuApi] = useState(0);
	// メニュー予算チェック結果
	const [menuCheckResult, setMenuCheckResult] = useState<boolean[]>([]);
	// メニュー予算チェック数
	const checkCount = useRef(0);
	const checkCountZeus = useRef(0);
	const checkCountMs = useRef(0);
	// メッセージフラグ
	const [messageFlag, setMessageFlag] = useState(false);
	// 操作前データ
	const beforeData = useRef<AccountBudget>();
	const resultApi = useRef(-1);
	const logTime = useRef("");
	// メニュー別上限下限予算定義
	type LimitAmount = {
		budgetNo:number,
		menuid:number,
		cpmThismonth: number,
		cpmThresholdThismonth: number,
		cpmNextmonth: number,
		cpmThresholdNextmonth: number,
	}
	const [limitAmounts, setLimitAmounts] = useState<LimitAmount[]>([]);
	// アカウントグループの権限取得
	const isAccountGroupAuth = IsAccountGroupAuth(accountgroupId, APOLLO_GROUP_OPERATOR);
	// 認証期間切れ関連宣言
	// リダイレクト
	const history = useHistory();
	// ドロワー
	const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
	// 予算合計差分
	const [diffAmount, setDiffAmount] = useState(0);
	// Zeus配信種別予算合計差分
	const [zeusDiffAmount, setZeusDiffAmount] = useState(0);
	// Zeus配信種別リセットボタン
	const [zeusResetAmount, setZeusResetAmount] = useState(false);
	// Zeus配信種別予算変更ボタン
	const [zeusChangeAmount, setZeusChangeAmount] = useState(false);
	// Zeus配信種別予算変更
	const [zeusUpdateAvailability, setZeusUpdateAvailability] = useState(true);
	// Zeus配信種別予算変更有無
	const [zeusAmountModified, setZeusAmountModified] = useState(false);

	// エラーメッセージ初期化
	const errorInit = () => {
		setErrorLocal("");
		if (!budgetnoMaster) return;
		var message:string[] = [];
		budgetnoMaster.map((_) => {
			message.push("");
		});
		setErrorMenuLocal(message);
	}

	// 処理対象年月Effect
	useEffect(() => {
		setBudgetMonth(yearMonth); 
		initStatus();
	}, [accountId, yearMonth]);

	// アカウント予算入力Effect
	useEffect(() => {
		if (progress) return;
		var oldAmount = oldNextBudgetAmount ? oldNextBudgetAmount : 0;
		if (budgetMonth === budgetMonth1) {
			oldAmount = oldBudgetAmount ? oldBudgetAmount : 0;
		}
		if (budgetAmount !== oldAmount) {
			// アカウントメニュー予算入力不可
			var workMenuDisabled:boolean[] = [];
			menuAmount.map((_) => {
				workMenuDisabled.push(true);
				return null;
			});
			setMenuDisabled(workMenuDisabled);
			// アカウントメニュー予算変更ボタン活性化
			setUpdateMenuAvailability(false);
			// 変更確認ダイアログメッセージ設定
			setMenuNames("アカウント");
			// Zeus配信種別予算コンポーネント非活性化
			setZeusIsDisabled(true);
		} else {
			// アカウントメニュー予算入力状態初期化
			setMenuDisabled(oldMenuDisabled);
			// アカウントメニュー予算変更ボタン非活性化
			setUpdateMenuAvailability(true);
		}
		// メニュー予算合計・差分をセットする
		calcMenuAmountTotal(menuAmount, budgetAmount);
		// エラーメッセージ初期化
		// errorInit();
	}, [budgetAmount]);

	// メニュー予算入力Effect
	useEffect(() => {
		if (progress) return;
		if (oldMenuAmountList && menuAmount && menuAmount.length > 0 && complete) {
			if (reset) {
				setReset(false);
				return;
			}
			var idx = 1;
			if (budgetMonth === budgetMonth1) {
				idx = 0;
			}
			var valueTotal = 0;
			var disabled = true;
			var workMenuNames = "";
			// アカウントメニュー予算変更ボタン活性化・非活性化
			menuAmount.map((amount, index) => {
				if (amount !== oldMenuAmountList[idx][index] || messageOld[index] !== "") {
					disabled = false;
					if (workMenuNames.length > 0) {
						workMenuNames += ",";
					}
					workMenuNames += menuName[index];
				}
				valueTotal += amount;
				return null;
			});
			// if (valueTotal === 0) return;
			if (disabled || messageFlag) {
				// 変更なし
				// アカウントメニュー予算入力状態初期化
				setMenuDisabled(oldMenuDisabled);
				// アカウントメニュー予算変更ボタン非活性化
				setUpdateMenuAvailability(true);
				// Zeus配信種別予算コンポーネント活性化
				setZeusIsDisabled(false);
			} else {
				// 変更あり
				// アカウントメニュー予算変更ボタン活性化
				setUpdateMenuAvailability(false);
				// Zeus配信種別予算コンポーネント非活性化
				setZeusIsDisabled(true);
			}
			setMenuNames(workMenuNames);
			// アカウント予算入力・活性化(メニュー無変更時)or非活性化(メニュー予算変更時)
			setBudgetDisabled(!disabled);
		}
		// メニュー予算合計・差分をセットする
		calcMenuAmountTotal(menuAmount, budgetAmount);
		// エラーメッセージ初期化
		// errorInit();
	}, [menuAmount]);

	// 予算枠番号マスター取得
	useEffect(() => {
		setmsg({
			type: "loading",
			payload: {
				...data,
				loading: true,
			}
		});
		setComplete(false);
		// 予算枠番号マスター取得
		const path = apollo_budgetno_master_path;
		ApolloAxios.get(path).then(response => {
			if (response.data.resultCode === 0) {
				initBudgetno(response.data.result);
			} else {
				console.log(response.data.message)
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_BUDGET_EDIT,"E","0"),
						loading: false,
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}, []);
		
	// 広告主アカウント月額予算取得 (個別)
	useEffect(() => {
		setmsg({
			type: "loading",
			payload: {
				...data,
				loading: true,
			}
		});
		// 広告主アカウント月額予算取得 (個別)
		const url = apollo_budget_path + "/" + accountId + "/" + budgetMonth1;
		ApolloAxios.get(url).then(response => {
			if (response.data.resultCode === 0) {
				setmsg({
					type: "loading",
					payload: {
						...data,
						loading: false,
					}
				});
				setAccountBudget(response.data.result);
				// initStatus();
				// 操作前データ保存
				beforeData.current = JSON.parse(JSON.stringify(response.data.result));
			} else {
				console.log(response.data.message);
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_BUDGET_EDIT,"E","1"),
						loading: false
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}, [reRead]);

	// メニュー上限下限予算(stateにセットするための変数)
	var menuLimitList:LimitAmount[] = [];
	// PFアカウント情報取得(メニュー別上限下限予算取得)
	useEffect(() => {
		if (!accountBudget?.amounts) return;
		accountBudget?.amounts.map((amount) => {
			if (amount.menuId === 1) {
				// Zeus
				if (amount.budgetNo === 10) {
					setmsg({
						type: "loading",
						payload: {
							...data,
							loading: true,
						}
					});
					const url = `${zeus_ad_account}${amount.platformAccountId}`;
					ApolloAxios.get(url).then((response) => {
						setmsg({
							type: "loading",
							payload: {
								...data,
								loading: false,
							}
						});
						var limitAmount:LimitAmount = {
							budgetNo:amount.budgetNo,
							menuid:amount.menuId,
							cpmThismonth: response.data.budgetLimit ? response.data.budgetLimit : -1,
							cpmThresholdThismonth: response.data.BudgetLowerLimitCurrentMonth
							? response.data.BudgetLowerLimitCurrentMonth
							: -1,
							cpmNextmonth: response.data.budgetLimitNextMonth ? response.data.budgetLimitNextMonth : -1,
							cpmThresholdNextmonth: -1,
						};
						menuLimitList.push(limitAmount);
						setLimitAmounts(JSON.parse(JSON.stringify(menuLimitList)));
					}).catch(err => {
						// 認証期間切れ判定とエラーメッセージ表示
						if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","10"), data, setmsg, history, setDrawerState, drawerState)) {
							// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
						}
					});
				} else {
					var limitAmount:LimitAmount = {
						budgetNo:amount.budgetNo,
						menuid:amount.menuId,
						cpmThismonth: -1,
						cpmThresholdThismonth: -1,
						cpmNextmonth: -1,
						cpmThresholdNextmonth: -1,
					};
					menuLimitList.push(limitAmount);
					setLimitAmounts(JSON.parse(JSON.stringify(menuLimitList)));
				}
			} else if (amount.menuId === 2) {
				// MS
				// MSは編集操作時に取得するので、ここでは初期データをセットする
				var limitAmount:LimitAmount = {
					budgetNo:amount.budgetNo,
					menuid:amount.menuId,
					cpmThismonth: -1,
					cpmThresholdThismonth: -1,
					cpmNextmonth: -1,
					cpmThresholdNextmonth: -1,
				};
				menuLimitList.push(limitAmount);
				setLimitAmounts(JSON.parse(JSON.stringify(menuLimitList)));
			}
		})
	}, [accountBudget]);

	// メニュー関連変数初期化
	const initBudgetno = (budgetnoMasterList:BudgetnoMaster[]) => {
		setBudgetnoMaster(budgetnoMasterList.filter(b => b.budgetNo !== 22));
	}

	// 状態初期化
	const initStatus = () => {
		initButton();
		setBudgetDisabled(false);
	}

	// 変更ボタン初期化
	const initButton = () => {
		setUpdateAvailability(true);
		setUpdateMenuAvailability(true);
	}

	// アカウント月額予算変更ボタンハンドラ
	const handleChangeAmount = () => {
		// 再計算を実施し、エラー判定する
		if (!handleChangeTotal()) return;

		// 広告主アカウント月額予算登録・更新
		initStatus();
		// 選択中の年月予算をリストにセットする
		var workBudgetAmount = 0;
		var workNextBudgetAmount = 0;
		if (budgetMonth === budgetMonth1) {
			workBudgetAmount = budgetAmount;
			workNextBudgetAmount = oldNextBudgetAmount;
		} else {
			workBudgetAmount = oldBudgetAmount;
			workNextBudgetAmount = budgetAmount;
		}
		const requestAmount:BudgetPutReq = {
			budgetAmount: workBudgetAmount,
			nextBudgetAmount: workNextBudgetAmount,
		}

		// 操作日時をセット
		logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
		// 操作ログ出力(更新)
		resultApi.current = 0;
		writeLog();

		// アカウント月額予算登録・更新
		const url = apollo_budget_path + "/" + accountId + "/" + budgetMonth1;
		ApolloAxios.put(url, requestAmount).then(response => {
			if (response.data.resultCode === 0) {
				// 操作ログ(成功)
				resultApi.current = 1;
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "success",
						message: GetMessage("0",UI_BUDGET_EDIT,"I","0"),
					}
				});
				// エラー情報初期化
				errorInit();
				// 呼び出し元・再読み込み
				setRead(!read);
				setReRead(!reRead);
			} else {
				// 操作ログ(失敗)
				resultApi.current = 9;
				console.log(response.data.message);
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_BUDGET_EDIT,"E","5"),
					}
				});
			}
		}).catch(err => {
			// 操作ログ(失敗)
			resultApi.current = 9;
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","5"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		}).finally(() => {
			// 操作ログ出力(結果)
			writeLog();
		})
	};

	// アカウントメニュー変更後月額予算取得
	const getMenuBudget = () => {
		var workAmounts:Amount[] = accountBudget?.amounts ? accountBudget.amounts : [];
		var works:Amount[] = [];
		budgetnoMaster.map((budgetno, index) => {
			var work:Amount = {
				budgetNo: budgetno.budgetNo,
				budgetName: budgetno.budgetName,
				budgetAmount: 0,
				nextBudgetAmount: 0,
				menuId: parseInt((budgetno.budgetNo / 10) + ""),
				platformAccountId: "",
			};
			workAmounts.map((workAmount) => {
				if (budgetno.budgetNo === workAmount.budgetNo) {
					if (budgetMonth === budgetMonth1) {
						work.budgetAmount = menuAmount[index];
					} else {
						work.nextBudgetAmount = menuAmount[index];
					}
				}
				return null;
			});
			works.push(work);
			return null;
		});
		return works;
	}

	// アカウントメニューMSチェック用予算取得
	const getMenuBudgetCheck = () => {
		var workAmounts:Amount[] = accountBudget?.amounts ? accountBudget.amounts : [];
		var works:AmountCheck[] = [];
		budgetnoMaster.map((budgetno, index) => {
			var work:AmountCheck = {
				budgetNo: budgetno.budgetNo,
				budgetName: budgetno.budgetName,
				budgetAmount: 0,
				nextBudgetAmount: 0,
				menuId: parseInt((budgetno.budgetNo / 10) + ""),
				platformAccountId: "",
				budgetAmountMin: 0,
				nextBudgetAmountMin: 0,
				budgetAmountOld: 0,
				nextBudgetAmountOld: 0,
			};
			workAmounts.map((workAmount) => {
				if (budgetno.budgetNo === workAmount.budgetNo) {
					if (budgetMonth === budgetMonth1) {
						work.budgetAmount = menuAmount[index];
						work.budgetAmountMin = minMenuAmount[0][index];
						work.budgetAmountOld = oldMenuAmountList ? oldMenuAmountList[0][index] : 0;
						work.nextBudgetAmount = oldMenuAmountList ? oldMenuAmountList[1][index] : 0;
						work.nextBudgetAmountMin = minMenuAmount[1][index];
						work.nextBudgetAmountOld = oldMenuAmountList ? oldMenuAmountList[1][index] : 0;
					} else {
						work.budgetAmount = oldMenuAmountList ? oldMenuAmountList[0][index] : 0;
						work.budgetAmountMin = minMenuAmount[0][index];
						work.budgetAmountOld = oldMenuAmountList ? oldMenuAmountList[0][index] : 0;
						work.nextBudgetAmount = menuAmount[index];
						work.nextBudgetAmountMin = minMenuAmount[1][index];
						work.nextBudgetAmountOld = oldMenuAmountList ? oldMenuAmountList[1][index] : 0;
					}
				}
				return null;
			});
			works.push(work);
			return null;
		});
		return works;
	}

	// 更新リクエスト用アカウントメニュー変更後月額予算取得
	const getMenuBudgetReq = () => {
		var workAmounts:Amount[] = accountBudget?.amounts ? accountBudget.amounts : [];
		budgetnoMaster.map((budgetno, index) => {
			workAmounts.map((workAmount) => {
				if (budgetno.budgetNo === workAmount.budgetNo) {
					if (budgetMonth === budgetMonth1) {
						workAmount.budgetAmount = menuAmount[index];
					} else {
						workAmount.nextBudgetAmount = menuAmount[index];
					}
				}
				return null;
			});
			return null;
		});
		return workAmounts;
	}

	// 月額予算変更ボタンハンドラ
	const handleChangeMenu = () => {
		if (zeusAmountModified) {
			// 配信種別毎変更起動
			setZeusChangeAmount(true);
			return;
		}
		// アカウント月額予算変更判定
		if (menuNames === "アカウント") {
			handleChangeAmount();
			return;
		}
		// 再計算を実施し、エラー判定する
		handleChangeTotal();
	}

	// 広告主アカウントメニュー月額予算登録・更新
	useEffect(() => {
		// 画面ロード時は、リターンする(スキップ)
		if (menuApi === 0) return;
		initStatus();
		const requestAmount:BudgetMenuPutReq = {
			amounts: getMenuBudgetReq(),
		}
		
		// 操作日時をセット
		logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
		// 操作ログ出力(更新)
		resultApi.current = 0;
		writeLog();

		// アカウントメニュー月額予算更新
		// const url = apollo_budget_menu_path + "/" + accountId + "/" + budgetMonth1;
		const url = apollo_budget_menu_path + "/" + accountId + "/" + budgetMonth;
		ApolloAxios.put(url, requestAmount).then(response => {
			if (response.data.resultCode === 0) {
				// 操作ログ(成功)
				resultApi.current = 1;
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "success",
						message: GetMessage("0",UI_BUDGET_EDIT,"I","0"),
					}
				});
				setMessageFlag(false);
				// エラーメッセージ初期化
				errorInit();
				// 呼び出し元・再読み込み
				setRead(!read);
				setReRead(!reRead);
			} else {
				// 操作ログ(失敗)
				resultApi.current = 9;
				console.log(response.data.message);
				const errMsg = response.data.message ? response.data.message : GetMessage("0",UI_BUDGET_EDIT,"E","6");
				// メニューを赤くする
				dispMenuError(errMsg);
				// エラーメッセージ表示
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "error",
						message: errMsg,
					}
				});
				// アカウント月額予算を入力不可にする
				setBudgetDisabled(true);
				setMessageFlag(true);
				// 呼び出し元・再読み込み
				setRead(!read);
			}
		}).catch(err => {
			// 操作ログ(失敗)
			resultApi.current = 9;
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","6"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		}).finally(() => {
			// 操作ログ出力(結果)
			writeLog();
		})
	}, [menuApi]);

	// 表示データ変更Effect
	useEffect(() => {
		setData();
	}, [budgetnoMaster, accountBudget, limitAmounts]);

	// 呼び出し元画面の表示年月と同じデータを初期表示する
	useEffect(() => {
		if (yearMonth !== budgetMonth1) {
			// 翌月にする
			handleChange2();
		}
	}, []);

	// 予算表示設定
	const setData = () => {
		if (!(budgetnoMaster && accountBudget && accountBudget.amounts && budgetnoMaster.length > 0)) return;
		if (limitAmounts.length < accountBudget.amounts.length) return;
		// 広告主アカウント予算セット
		setBudgetAmount(accountBudget.budgetAmount);
		setBudgetAmountBack(accountBudget.budgetAmount);
		setNextBudgetAmount(accountBudget.nextBudgetAmount);
		setOldBudgetAmount(accountBudget.budgetAmount);
		setOldNextBudgetAmount(accountBudget.nextBudgetAmount);

		var workMenuName:string[] = [];
		var workMenuAmount1:number[] = [];
		var workMenuAmount2:number[] = [];
		var workMenuDisabled:boolean[] = [];
		var workMinMenuAmount:number[][] = [];
		var workMaxMenuAmount:number[][] = [];
		var work1:number[] = [];
		var work2:number[] = [];
		var work3:number[] = [];
		var work4:number[] = [];
	
		var workMessage = "";
		var workMessage2 = "";
		var workMessageList:string[] = [];
		// メニュー利用可否を判定する
		budgetnoMaster.map((budgetno, idx1) => {
			var workMessageMenu= "";
			// テキストフィールドラベル名セット
			workMenuName[idx1] = budgetno.budgetName
			// メニュー利用可否を判定する
			var max = parseInt((accountBudget ? accountBudget.creditLimitAmount : 0) / 3 + "");
			var cost = 0;
			var perCost = 0;
			var costNext = 0;
			var workMax = max;
			var workNextMax = max;
			var workDisabled = true;
			var workAmounts = [0,0];
			accountBudget.amounts.map((amount) => {
				if (amount.budgetNo === budgetno.budgetNo) {
					workAmounts = [amount.budgetAmount, amount.nextBudgetAmount];
					workDisabled = false;
					// メニュー別下限予算セット
					limitAmounts && limitAmounts.map((limit) => {
						if (limit.budgetNo === budgetno.budgetNo) {
							if (limit.menuid === 2) {
								// MSの場合は0を当月・翌月下限値にセットする
								cost = 0;
								costNext = 0;
							} else {
								if (cost < limit.cpmThresholdThismonth && limit.cpmThresholdThismonth >= 0) {
									cost = limit.cpmThresholdThismonth;
								}
								// 翌月下限予算値セット
								if (costNext < limit.cpmThresholdNextmonth && limit.cpmThresholdNextmonth >= 0) {
									costNext = limit.cpmThresholdNextmonth;
								}
							}
							workMax = max;
							workNextMax = max;
						}
						return null;
					});
					if (amount.message !== "") {
						if (amount.message !== workMessage2) {
							if (workMessage !== "") {
								workMessage += "\r\n";
							}
							workMessage += amount.message;
							workMessage2 = amount.message;
						}
						workMessageMenu = amount.message;
					}
				}
				return null;
			});
			workMessageList.push(workMessageMenu);
			workMenuDisabled.push(workDisabled);
			workMenuAmount1.push(workAmounts[0]);
			workMenuAmount2.push(workAmounts[1]);
			work1.push(cost);
			work2.push(costNext);
			work3.push(workMax);
			work4.push(workNextMax);
			return null;
		});
		workMinMenuAmount.push(work1, work2);
		workMaxMenuAmount.push(work3, work4);
		setMinMenuAmount(workMinMenuAmount);
		setMaxMenuAmount(workMaxMenuAmount);
		// 予算枠名称セット
		setMenuName(workMenuName);
		if (budgetMonth === budgetMonth1) {
			// 当月予算セット
			setMenuAmount(workMenuAmount1);
			// メニュー予算合計・差分をセットする
			calcMenuAmountTotal(workMenuAmount1, accountBudget.budgetAmount);
		} else {
			// 翌月予算セット
			setBudgetAmount(accountBudget.nextBudgetAmount);
			setMenuAmount(workMenuAmount2);
			// メニュー予算合計・差分をセットする
			calcMenuAmountTotal(workMenuAmount2, accountBudget.nextBudgetAmount);
		}
		setMenuDisabled(workMenuDisabled);
		// メニュー予算入力可否を保存
		setOldMenuDisabled(JSON.parse(JSON.stringify(workMenuDisabled)));

		setUpdateAvailability(true);
		setUpdateMenuAvailability(true);
		// 予算額を保存
		setOldMenuAmountList(JSON.parse(JSON.stringify([workMenuAmount1, workMenuAmount2])));
		// setDataPerformance();
		setComplete(true);
		// エラーメッセージ表示
		dispError(workMessage);
		setMessageOld(workMessageList);
		// アカウント予算変更ボタン活性化
		setProgress(false);
	}

	// メニューエラー表示
	const dispMenuError = (workMessage:string) => {
		if (workMessage !== "") {
			// エラーメッセージからメニューを特定する
			var wErrorMenuLocal = [];
			var messageList = workMessage.split("\r\n");
			for (var idx1 in budgetnoMaster) {
				var errorFlag = false;
				for (var idx2 in messageList) {
					var budgetName = messageList[idx2].substring(0, messageList[idx2].indexOf("「"));
					if (budgetName === budgetnoMaster[idx1].budgetName) {
						errorFlag = true;
						break;
					}
				}
				if (errorFlag) {
					wErrorMenuLocal.push("予算更新に失敗しました。再度変更ボタンを押下してください。");
				} else {
					wErrorMenuLocal.push("");
				}
			}
			// エラーの発生しているメニューにエラー文言を表示する
			setErrorMenuLocal(wErrorMenuLocal);
		}
	}

	// エラーメッセージ表示
	const dispError = (workMessage:string) => {
		if (workMessage !== "") {
			if (isAccountGroupAuth) {
				var localMessage = GetMessage("0",UI_BUDGET_EDIT,"E","9") + workMessage;
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "error",
						message: localMessage,
					}
				});
			}
			// メニューを赤くする
			dispMenuError(workMessage);
			// メッセージフラグON
			setMessageFlag(true);
			// アカウント月額予算を入力不可にする
			setBudgetDisabled(true);
			// 配信種別月額予算を入力不可にする
			setZeusIsDisabled(true);
			// setUpdateMenuAvailability(false);
		} else {
			// メッセージフラグOFF
			setMessageFlag(false);
			// Zeus配信種別予算コンポーネント活性化
			setZeusIsDisabled(false);
		}
	}
	// エラーメッセージの位置にスクロール	
	// useLayoutEffect(() => {
	// 		//@ts-ignore
	// 		messageRef.current.scrollIntoView({behavior: 'smooth',	});
	// }, [messageFlag]);
	
	//// 共通コンポーネントプロパティ定義
	// アカウント月額予算テキスト引数
	var propsTextNumber:PropsTextNumber = {
		label: "アカウント月額予算",
		setValue: setBudgetAmount,
		value: budgetAmount ? budgetAmount : 0,
		minValue: 0,
		maxValue: parseInt((accountBudget?.creditLimitAmount ? accountBudget.creditLimitAmount : MAX_ACCOUNT_BUDGET	* 3) / 3 + ""),
		isDisabled: budgetDisabled || messageFlag || !isAccountGroupAuth,
		required: false,
		message: errorLocal,
	};

	// メニューprops作成
	var propsTextNumberListWork:PropsTextNumberList[] = [];
	// 表示データ変更Effect
	useEffect(() => {
		// エラーメッセージ初期化
		errorInit();
	}, [budgetnoMaster]);

	// メニュー予算props引数
	accountBudget && budgetnoMaster.map((_, index) => {
		var workPropsTextNumberList:PropsTextNumberList = {
			label: menuName[index] ?? menuName[index],
			setValue: setMenuAmount,
			valueList: menuAmount ?? menuAmount,
			index: index,
			value: menuAmount[index] ?? menuAmount[index],
			isDisabled: menuDisabled[index] && menuDisabled[index] || !isAccountGroupAuth || progress,
			required: false,
			message: errorMenuLocal,
			fieldName: "name" + index,
			minValue: 0,
		}
		propsTextNumberListWork.push(workPropsTextNumberList);
		return null;
	});

	// 合計
	var propsTextNumber5:PropsTextNumber = {
		label: "合計",
		setValue: setTotalAmount,
		value: totalAmount,
		minValue: 0,
		maxValue: MAX_ACCOUNT_BUDGET,
		isDisabled: true,
		required: false,
	};

	// Zeus配信種別予算変更により呼び出される
	const setIsDisabled = (isDisabled: boolean) => {
		// アカウント予算入力・活性化(メニュー無変更時)or非活性化(メニュー予算変更時)
		setBudgetDisabled(isDisabled);
		if (isDisabled) {
			// アカウントメニュー予算入力不可
			var workMenuDisabled:boolean[] = [];
			menuAmount.map((_) => {
				workMenuDisabled.push(isDisabled);
				return null;
			});
			setMenuDisabled(workMenuDisabled);
		} else {
			setMenuDisabled(oldMenuDisabled);
		}
		setZeusAmountModified(isDisabled);
	}
	// Zeus配信種別別月額予算props
	var propsBudgetDeliveryType:PropsBudgetDeliveryType = {
		menuDisabled: oldMenuDisabled,
		menuAmount: menuAmount,
		isAccountGroupAuth: isAccountGroupAuth,
		budgetMonth1: budgetMonth1,
		budgetMonth2: budgetMonth2,
		budgetMonth: budgetMonth,
		accountBudget: 	accountBudget,
		zeusIsDisabled: zeusIsDisabled,
		setIsDisabled: setIsDisabled,
		drawerState: drawerState,
		setDrawerState: setDrawerState,
		history: history,
		complete: complete,
		read: read,
		setRead: setRead,
		setDiffAmount: setZeusDiffAmount,
		progress: progress,
		resetAmount: zeusResetAmount,
		setResetAmount: setZeusResetAmount,
		changeAmount: zeusChangeAmount,
		setChangeAmount: setZeusChangeAmount,
		updateAvailability: zeusUpdateAvailability,
		setUpdateAvailability: setZeusUpdateAvailability,
		setMenuNames: setMenuNames,
	};

	// 当月変更ハンドラ
	const handleChange1 = () => {
		setBudgetMonth(budgetMonth1);
		setDisabledButton1(true);
		// 当月予算セット
		setBudgetAmount(budgetAmountBack);
		// メニュー予算初期化
		initMenuAmount(budgetMonth1);
		// メニュー予算合計・差分をセットする
		calcMenuAmountTotal(oldMenuAmountList ? oldMenuAmountList[0] : menuAmount, budgetAmountBack);
		// 予算額入力活性化状態を初期に戻す
		setMenuDisabled(oldMenuDisabled);
		// 親画面の年月を当月にセットする
		setParentYearMonth(budgetMonth1);
		// ダイアログ表示用
		setMonth("当月");
		setMenuNames("");
	};

	// 翌月変更ハンドラ
	const handleChange2 = () => {
		setBudgetMonth(budgetMonth2);
		setDisabledButton1(false);
		// 翌月予算セット
		setBudgetAmount(nextBudgetAmount);
		// メニュー予算初期化
		initMenuAmount(budgetMonth2);
		// メニュー予算合計・差分をセットする
		calcMenuAmountTotal(oldMenuAmountList ? oldMenuAmountList[1] : menuAmount, nextBudgetAmount);
		// 予算額入力活性化状態を初期に戻す
		setMenuDisabled(oldMenuDisabled);
		// 親画面の年月を翌月にセットする
		setParentYearMonth(budgetMonth2);
		// ダイアログ表示用
		setMonth("翌月");
		setMenuNames("");
	};
	
	// 初期メニュー予算セット
	const initMenuAmount = (argMonth: string) => {
		var idx = 0;
		if (argMonth !== budgetMonth1) {
			idx = 1;
		}
		setReset(true);
		if (oldMenuAmountList) {
			setMenuAmount(JSON.parse(JSON.stringify(oldMenuAmountList[idx])));
		}
	}

	// アカウント予算変更有無判定
	const setChangeAmount = () => {
		var result = true;
		var amount = oldNextBudgetAmount;
		if (budgetMonth === budgetMonth1) {
			amount = oldBudgetAmount;
		}
		if (budgetAmount !== amount) {
			result = false;
		}
		setUpdateAvailability(result);
		return result;
	};

	// メニュー合計予算算出・差分算出セット
	 const calcMenuAmountTotal = (menuAmountList: number[], amount: number) => {
		let total = getTotalAmount(menuAmountList);
		setTotalAmount(total);
		// 差分算出
		let workAmount = amount - total;
		setRegisterableAmount(workAmount);
		setDiffAmount(workAmount);
	};

	// アカウント予算上限下限チェック
	const checkBudgetMinMax = () => {
		var errMessage = "";
		// メニュー予算上限チェック対応
		var max = parseInt(accountBudget ? accountBudget.creditLimitAmount / 3 + "" : "");
		if (max > MAX_ACCOUNT_BUDGET) {
			max = MAX_ACCOUNT_BUDGET;
		}
		// アカウント予算チェック
		if (budgetAmount < 0) {
			errMessage = "0 以上を入力して下さい。";
		} else if (budgetAmount > max) {
			errMessage = max + " 以下を入力して下さい。";
		}
		setErrorLocal(errMessage);
		if (errMessage === "") return false;
		return true
	}

	// メニュー予算チェックを得て、予算変更実行またはエラーメッセージ表示
	useEffect(() => {
		if (menuCheckResult.length === 0) return;
		if (checkCount.current !== 0) return;
		var errorMessages:string[] = [];
		var msgOrg = errorMsg.current;
		for (var key in msgOrg) {
			if (msgOrg[key]) {
				errorMessages.push(msgOrg[key]);
			}
		}
		if (errorMessages.length === 0) {
			// メニュー予算変更API起動
			setMenuApi(menuApi+1);
		} else {
			var msg = errorMessages.join("\r\n");
			// メニュー予算エラー表示
			setmsg({
				type: "all",
				payload: {
					...data,
					open: true,
					type: "error",
					message: msg,
					loading: false,
				}
			});
			errorMsg.current = {};
		}
		setMenuCheckResult([]);
	}, [menuCheckResult]);

	// メニュー予算チェック
	const checkMenuBudget = () => {
		if (!accountBudget) return;
		checkCount.current = 0;
		checkCountZeus.current = 0;
		checkCountMs.current = 0;
		// メニュー毎のエラーメッセージ定義
		var msg = {};
		accountBudget.amounts.map((amount) => {
			// チェック数カウントアップ
			checkCount.current += 1;
			switch(amount.menuId) {
				case 1:
					checkCountZeus.current += 1;
					break;
				default:
					checkCountMs.current += 1;
			}
			return null;
		});
		// メニュー毎のエラーメッセージセット
		errorMsg.current = msg;
		var menuBak:number[] = []
		accountBudget.amounts.map((amount) => {
			var flag = false;
			menuBak.map((menuBk) => {
				if (amount.menuId === menuBk) {
					flag = true;
				}
			});
			if (!flag) {
				if (amount.menuId === 2) {
					// MS予算チェック
					checkMsBudget();
				} else {
					// MS以外予算チェック
					checkZeusShBudget(amount.menuId);
				}
				menuBak.push(amount.menuId);
			}
		});
	}

	// Zeus,SH予算チェック
	const checkZeusShBudget = (menuId: number) => {
		var errMsg = ""
		var menuBudgetList = getMenuBudgetCheck();
		// 予算下限値未満チェック
		for (var i in menuBudgetList) {
			if (menuBudgetList[i].menuId === menuId) {
				for (var j in limitAmounts) {
					if (limitAmounts[j].menuid === menuBudgetList[i].menuId) {
						if (budgetMonth === budgetMonth1 ) {
							// 旧予算と同じであればエラーとしない
							if (menuAmount[i] < limitAmounts[j].cpmThresholdThismonth && oldMenuAmountList && oldMenuAmountList[0][i] !== menuAmount[i]) {
								// 当月予算下限値未満
								errMsg = menuBudgetList[i].budgetName + "「当月の月予算を変更する場合は、" + limitAmounts[j].cpmThresholdThismonth + "円以上を設定してください。」";
							}
						} else {
							if (menuAmount[i] < limitAmounts[j].cpmThresholdNextmonth && oldMenuAmountList && oldMenuAmountList[1][i] !== menuAmount[i]) {
								// 翌月予算下限値未満
								errMsg = menuBudgetList[i].budgetName + "「翌月の月予算を変更する場合は、" + limitAmounts[j].cpmThresholdNextmonth + "円以上を設定してください。」";
							}
						}
					}
				}
			}
		}
		if (errMsg) {
			// エラーメッセージ設定
			var errorMsgList = errorMsg.current;
			errorMsgList[menuId] = errMsg;
			errorMsg.current = errorMsgList;
		}
		// チェック終了
		var menuCheckResultWork = JSON.parse(JSON.stringify(menuCheckResult));
		menuCheckResultWork.push(true);
		setMenuCheckResult(menuCheckResultWork);
		// チェック数カウントダウン
		if (menuId === 1) {
			checkCount.current -= checkCountZeus.current;
		}
	}
	// MS予算チェック
	const checkMsBudget = () => {	
		var menuBudgetList = getMenuBudgetCheck();
		// 2度呼び出さないためのフラグ
		var firstFlag = false;
		var changeFlag = false;
		for (var i in menuBudgetList) {
			if (menuBudgetList[i].menuId === 2) {
				if (budgetMonth === budgetMonth1 ) {
					// 旧予算と同じであればエラーとしない
					if (oldMenuAmountList && oldMenuAmountList[0][i] !== menuAmount[i]) {
						changeFlag = true
					}
				} else {
					if (oldMenuAmountList && oldMenuAmountList[1][i] !== menuAmount[i]) {
						changeFlag = true
					}
				}
			}
		}
		if (changeFlag) {
			accountBudget?.amounts.map((amount) => {
			if (amount.menuId === 2) {
				if (!firstFlag) {
					firstFlag = true;
					changeFlag = false;
					
					// RTM対応
					accountBudget?.amounts.map((amount2) => {
						menuBudgetList.map((limitAmount) => {
							if (limitAmount.budgetNo === amount2.budgetNo) {
								if (limitAmount.budgetNo === 21) {
									// メッセージS
									limitAmount.platformAccountId = amount.platformAccountId
								} else if (limitAmount.budgetNo === 22) {
									// リアルタイムメッセージS
									limitAmount.platformAccountId = amount.platformAccountId
								}
							}
						});
					});
					// メニュー予算チェックリクエスト作成
					const requestAmount:BudgetMenuPutReq = {
						amounts: menuBudgetList,
					}
					setmsg({
						type: "loading",
						payload: {
							...data,
							loading: true,
						}
					});
					// APIで判定
					const url = apollo_menu_budget_check_path + "/" + accountId + "/" + budgetMonth;
					ApolloAxios.post(url, requestAmount).then(response => {
						if (response.data.resultCode === 0) {
							setmsg({
								type: "loading",
								payload: {
									...data,
									loading: false,
								}
							});
						} else {
							// エラーメッセージ設定
							var errorMsgList = errorMsg.current;
							errorMsgList[amount.menuId] = response.data.message;
							errorMsg.current = errorMsgList;
						}
					}).catch(err => {
						// 認証期間切れ判定とエラーメッセージ表示
						if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","7"), data, setmsg, history, setDrawerState, drawerState)) {
							// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
							var errorMsgList = errorMsg.current;
							errorMsgList[amount.menuId] = err.errmsg ? err.errmsg : GetMessage("0",UI_BUDGET_EDIT,"E","7");
							errorMsg.current = errorMsgList;
						}
					}).finally(() => {
						// チェック終了
						var menuCheckResultWork = JSON.parse(JSON.stringify(menuCheckResult));
						menuCheckResultWork.push(true);
						setMenuCheckResult(menuCheckResultWork);
						// チェック数カウントダウン
						checkCount.current -= checkCountMs.current;
					});
				}
			}
		});
	} else {
			// チェック終了
			var menuCheckResultWork = JSON.parse(JSON.stringify(menuCheckResult));
			menuCheckResultWork.push(true);
			setMenuCheckResult(menuCheckResultWork);
			// チェック数カウントダウン
			checkCount.current -= checkCountMs.current;
		}
	}

	// 再計算
	const handleChangeTotal = () => {
		// アカウント予算上限値チェック
		if (checkBudgetMinMax()) {
			return false;
		}
		calcMenuAmountTotal(menuAmount, budgetAmount);
		let total = getTotalAmount(menuAmount);
		// 差分算出
		let workAmount = budgetAmount - total;
		// 変更した予算のみ変更ボタン活性化
		if (workAmount < 0) {
			return false;
		}
		// アカウント予算変更の場合、メニュー予算のチェックは行わない
		if (!setChangeAmount()) {
			return true;
		}
		// メニュー予算変更チェックと更新起動
		checkMenuBudget();
		return false;
	};

	// 合計金額取得
	const getTotalAmount = (menuAmountList: number[]) => {
		var total = 0;
		menuAmountList.map((amount) => {
			total += amount;
			return null;
		});
		return total;
	};

	// 予算額リセット
	const resetAmount = () => {
		// Zeus予算額リセット
		setZeusResetAmount(true);
		var workBudgetAmount = oldBudgetAmount;
		var idx = 0;
		if (budgetMonth !== budgetMonth1) {
			workBudgetAmount = oldNextBudgetAmount;
			idx = 1;
		}
		setBudgetAmount(workBudgetAmount);
		if (oldMenuAmountList !== undefined) {
			setMenuAmount(JSON.parse(JSON.stringify(oldMenuAmountList[idx])));
			// メニュー合計金額・差分を再計算表示する
			calcMenuAmountTotal(oldMenuAmountList[idx], workBudgetAmount);
		}
		setReset(true);
		// 予算額入力活性化状態を初期に戻す
		setMenuDisabled(JSON.parse(JSON.stringify(oldMenuDisabled)));
		// 更新ボタン活性化状態を初期に戻す
		initStatus();
		// エラーが発生した状態でのリセットボタン押下による配信種別予算入力活性化判定
		var workMessage = "";
		messageOld.map((v:string) => {
			workMessage += v;
		})
		if (workMessage === "") {
			// Zeus配信種別予算コンポーネント活性化
			setZeusIsDisabled(false);
		}
		// エラー情報初期化
		errorInit();
	};

	// 改行コードを<br />に変換
	const convMessage = (msg: string) => {
		const texts = msg.split(/(\r\n)/).map((item, index) => {
			return (
				<React.Fragment key={index}>
					{ item.match(/\r\n/) ? <br /> : item }
				</React.Fragment>
			);
		});
		return texts;
	}

	// 操作ログ出力
	const writeLog = () => {
		// 操作ログ出力を呼ばれるまでは処理しない
		if (resultApi.current < 0) return;
		// 項目リスト
		var itemList: ItemList[] = [
			{
				key: "アカウント月額予算",
				beforeValue: budgetMonth === budgetMonth1 ? beforeData.current ? beforeData.current.budgetAmount + "" : "0" : beforeData.current ? beforeData.current.nextBudgetAmount + "" : "0",
				afterValue: budgetAmount + "",
			},
		];
		// 変更前メニュー予算金額
		const itemList1: ItemList[] = beforeData.current ? beforeData.current.amounts.map((budget:any) => {
			return {
				key: budget.budgetName + "",
				beforeValue: budgetMonth === budgetMonth1 ? budget.budgetAmount + "" : budget.nextBudgetAmount ? budget.nextBudgetAmount + "" : "0",
				afterValue: "0",
			}
		}) : [];
		// 変更後メニュー予算金額
		var itemList2: ItemList[] = accountBudget ? accountBudget.amounts.map((budget:any, idx:number) => {
			return {
				key: budget.budgetName,
				beforeValue: itemList1[idx].beforeValue + "",
				afterValue: budgetMonth === budgetMonth1 ? budget.budgetAmount + "" : budget.nextBudgetAmount ? budget.nextBudgetAmount + "" : "0",
			}
		}) : [];
		itemList = itemList.concat(itemList2);
		// メニュー名取得
		const menuList: string[] = beforeData.current ? beforeData.current.amounts.map((budget:any) => {
			return budget.budgetName;
		}) : [];
		const menus = menuList.join();
		// 操作ログ
		const executionLog: LogData = {
			eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:MM:SS“ 形式
			logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
			result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
			userID: state.userprofile.userId,// ユーザID
			userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
			accessToken: state.accesstoken, // APIアクセス用トークン
			accountGroupID: accountgroupId, // アカウントグループID
			accountGroupName: accountBudget ? accountBudget.accountgroupName : "", // アカウントグループ名
			accountID: accountId, // 広告主アカウントID
			accountName: accountBudget ? accountBudget.accountName : "", // 広告主アカウント名
			campaignID: "", // キャンペーンID
			campaignName: "", // キャンペーン名
			adGroupID: "", // 広告グループID
			adGroupName: "", // 広告グループ名
			menu: menus, // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
			displayName: "予算設定画面", // 操作画面名称 〇〇画面
			category: "予算", // 操作対象 キャンペーン / セグメント etc...
			actionType: "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
			targetID: resultApi.current === 0 ? "" : budgetMonth === budgetMonth1 ? budgetMonth1 + "" : budgetMonth2 + "", // 操作を行うデータのID 実行時は空文字
			targetName: resultApi.current === 0 ? "" : "年月", // 操作を行うデータの名称 実行時は空文字
			itemList: itemList,
		}
		// 操作ログ出力
		ApolloEventRecord(executionLog);
	};

	// 画面表示
	return (
		<Fragment>
			<Card square variant="outlined" style={{overflow:"auto"}}>
				<CardContent style={{padding:10}}>
					<Grid spacing={0} container>
						<Grid item xs={12} md={6}>
							<Typography>予算設定（{disabledButton1 ? "当月" : "翌月"}）</Typography>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography variant="button" display="block" align="right">
								{disabledButton1 ?
									<>
										<Button size="small"><span style={{borderBottom:"solid", borderColor:"red", borderWidth:"3px"}}>{dispMonth}</span></Button>
										<Box display="inline">|</Box>
										<Button color="primary" size="small" onClick={() => handleChange2()}><span style={{borderBottom:"solid", borderColor:"white", borderWidth:"3px"}}>{dispNextMonth}</span></Button>
									</>
									:
									<>
										<Button color="primary" size="small" onClick={() => handleChange1()}><span style={{borderBottom:"solid", borderColor:"white", borderWidth:"3px"}}>{dispMonth}</span></Button>
										<Box display="inline">|</Box>
										<Button size="small"><span style={{borderBottom:"solid", borderColor:"red", borderWidth:"3px"}}>{dispNextMonth}</span></Button>
									</>
								}
							</Typography>
						</Grid>
					</Grid>
				
					<Card className={classes.root} square variant="outlined" style={{padding: '0px'}}>
						<CardContent style={{padding:10}}>
							<Grid spacing={0} container>
								<Grid item xs={12} md={6}>
									<Typography variant="button">広告主アカウントID</Typography>
								</Grid>
								<Grid item xs={12} md={6}>
									<Typography variant="button">
										{accountBudget?.accountId}
									</Typography>
								</Grid>
								<Grid item xs={12} md={6}>
									<Typography variant="button">広告主アカウント名</Typography>
								</Grid>
								<Grid item xs={12} md={6}>
									<Typography variant="button">
										{accountBudget?.accountName}
									</Typography>
								</Grid>
								<Grid item xs={12} md={6}>
									<Typography variant="button">トラッカーID</Typography>
								</Grid>
								<Grid item xs={12} md={6}>
									<Typography variant="button">
										{accountBudget?.trackerId}
									</Typography>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					<Card className={classes.root} square variant="outlined">
						<CardContent style={{padding:10}}>
							<Grid spacing={0} container>
								{/* アカウント月額予算 */}
								<Grid item xs={12} md={11}>
									<ApolloTextNumber propsText={propsTextNumber}/>
								</Grid>
								<Grid item xs={12} md={1}>
									{"円"}
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption">
										{"※アカウント月額予算はメニュー別月額予算の合計値を下回ることはできません。"}
									</Typography>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					<Card className={classes.root} square variant="outlined" style={{overflow:"auto"}}>
					{/* <Card className={classes.root} square variant="outlined"> */}
						<CardContent style={{padding:10}}>
							<Grid spacing={0} container>
								<Grid item xs={12}>
									<Typography style={{overflowWrap:"anywhere"}}>{"メニュー別月額予算"}</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption" style={{overflowWrap:"anywhere"}}>
										{"※メニュー別月額予算の合計値はアカウント月額予算を超えることはできません。"}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption" style={{overflowWrap:"anywhere"}}>
										{"※メニュー別月額予算は既に消化済み/消化見込の金額より低い値を設定することはできません。"}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption" style={{color:"#ff0000", overflowWrap:"anywhere"}}>
										{"※パフォーマンス広告の月額予算はメニューとキャンペーン種別のどちらも設定が必要になります。"}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption" style={{color:"#ff0000", overflowWrap:"anywhere"}}>
										{"　請求金額はメニューで設定された値を上限値とし、キャンペーン種別で設定された月額予算は、配信時の上限値としてのみ使用します。"}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="caption" style={{color:"#ff0000", overflowWrap:"anywhere"}}>
										{"※パフォーマンス広告のキャンペーン種別別月額予算の合計値は、メニュー単位の設定金額を超えることはできません。"}
									</Typography>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					<Card className={classes.root} square variant="outlined">
						<CardContent style={{padding:10}}>
							{complete && budgetnoMaster && budgetnoMaster.length > 0 && budgetnoMaster.map((data, index) => {
								return (
									<Fragment key={index}>
										<Grid spacing={0} container>
											<Grid item xs={12} md={11}>
												<ApolloTextNumberList propsTextList={propsTextNumberListWork[index]}/>
											</Grid>
											<Grid item xs={12} md={1}>
												{"円"}
											</Grid>
										</Grid>
									</Fragment>
								)
							})}

							<Grid spacing={0} container>
								{/* 合計 */}
								<Grid item xs={12} md={10}>
									<Typography variant="body1" color="textPrimary">
										<ApolloTextNumber propsText={propsTextNumber5}/>
									</Typography>
								</Grid>

								{/* 再計算 */}
								<Grid item xs={12} md={2}>
								</Grid>
								<Grid item xs={12} md={10}>
									{registerableAmount >= 0 ?
										<Typography variant="body1" color="textPrimary">
										{"あと " + registerableAmount.toLocaleString() + " 円 設定可能"}
										</Typography>
									:
										<Typography variant="body1" color="error">
										{(0 - registerableAmount).toLocaleString() + " 円 超過しています"}
										</Typography>
									}
								</Grid>
								<Grid item xs={12} md={2}>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					{/* Zeus配信種別別月額予算 */}
					<ApolloBudgetDeliveryType propsBudgetDeliveryType={propsBudgetDeliveryType} />

					<CardActions className={classes.cardaction}>
						<ApolloButton handleButton={handleChangeMenu} button="変更" title="月額予算変更" text={`${menuNames}の${month}の月額予算を変更しますか？`} disabled={(updateMenuAvailability && zeusUpdateAvailability) && !messageFlag || !isAccountGroupAuth || diffAmount < 0 || zeusDiffAmount < 0}/>
						<Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>resetAmount()} disabled={!isAccountGroupAuth || progress}>
						{"リセット"}
						</Button>
					</CardActions>

				</CardContent>
			</Card>
		</Fragment>
	);
}
